import styled from 'styled-components'
import {Col, Row, InputNumber} from 'antd'
import { device } from '../../styles/devices';

export const TituloMenu = styled.h1`
  font-size: 20px;
  text-align: center;
  letter-spacing:2px;
  color: black;
  margin:0;
  padding:0;
  font-weight:400;
 
  @media ${device.laptop} { 
    font-size: 40px;
  }

  @media ${device.mobileL} { 
    font-size: 25px;
  }
`;

export const ColFlex= styled(Col)`
  display:flex;
  justify-content:center;
  align-items:center;
  box-sizing: border-box;
  margin-top:2em;
`;

export const RowStyle= styled(Row)`
   margin: 1em 0 1em 0;
`;

export const DivPedidoContenido = styled.div`
  font-size: 14px;
  letter-spacing:1px;
  color: black;
  font-weight:bold;

  span{
    color:#283c63;
  }
`;

export const StyledInputNumber= styled(InputNumber)`
  input {
    background-color: transparent;
    border-color: red;
    padding: 10px;
    height: auto;
    border-radius: 3px;
  },
  .ant-input-number {
    width:200px !important;
  }
`;